import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import './App.css';

const { 
  FiArrowLeft, FiCheck, FiX, FiTrendingUp, FiShield, 
  FiTarget, FiActivity, FiLayers, FiSettings, FiBarChart2,
  FiMessageSquare, FiSend, FiInfo, FiZap, FiExternalLink,
  FiUser, FiCpu, FiMoreHorizontal, FiGlobe
} = FiIcons;

const LOGO_URL = 'https://i.postimg.cc/SR5j5NZC/Profit-Lense-Ai-removebg-preview-(3).png';

const WIZARD_CONFIG = {
  'Low Risk': {
    Buying: [
      { 
        id: 'A', 
        title: 'Step A: Angle', 
        question: 'Is the angle line ( Green in color) making more than 30 Degree with reference to the yellow line and pointing upwards ?',
        icon: FiActivity,
        detail: 'Upward momentum is required for a bullish setup. A shallow angle might indicate a weak trend.',
        image: 'https://i.postimg.cc/FRhmf12D/upangle.png'
      },
      { 
        id: 'B', 
        title: 'Step B: Breakout', 
        question: 'is green candle shifted above breakout level shown in blue color ?',
        icon: FiTarget,
        detail: 'Confirm that the price has cleared the recent high with conviction and volume.',
        image: 'https://i.postimg.cc/pX7rSQJZ/upbreak.png'
      },
      { 
        id: 'C', 
        title: 'Step C: Candles', 
        question: 'Are Green candles climbing up like stairs making a higher high pattern ?',
        icon: FiLayers,
        detail: 'Look for strong buying pressure in the candle shapes. Lower wicks are a positive sign.',
        image: 'https://i.postimg.cc/jddKhWVF/photo-collage-png-(2).png'
      },
      { 
        id: 'M', 
        title: 'Step M: Money Flow', 
        question: 'Is the Green Moneyflow line moving in an upward direction ?',
        icon: FiSettings,
        detail: 'Capital should be entering the asset for a sustainable pump. Green MFI indicates net inflow.',
        image: 'https://i.postimg.cc/fTpzTwFg/moneyflow-UP.png'
      },
      { 
        id: 'P', 
        title: 'Step P: Percentage', 
        question: 'Is the percentage table showing 78% or more percent and is Green in color ?',
        icon: FiBarChart2,
        detail: 'Ensure the potential gain justifies the stop-loss distance. High probability trades respect 1:2.',
        image: 'https://i.postimg.cc/63njRh53/uppercentage.png'
      }
    ],
    Selling: [
      { 
        id: 'A', 
        title: 'Step A: Angle', 
        question: 'Is the angle line ( Red in color) making more than 30 Degree with reference to the yellow line and pointing Downwards ?',
        icon: FiActivity,
        detail: 'Downward momentum is required for a bearish setup. Negative angles show persistent selling.',
        image: 'https://i.postimg.cc/tTF5c4JQ/downangle.png'
      },
      { 
        id: 'B', 
        title: 'Step B: Breakout', 
        question: 'Is the Orange Breakout happening in the downward direction as shown ?',
        icon: FiTarget,
        detail: 'Confirm that the price has dropped below the recent low with high relative volume.',
        image: 'https://i.postimg.cc/hG0SKVVD/downbreak.png'
      },
      { 
        id: 'C', 
        title: 'Step C: Candles', 
        question: 'Are Red candles climbing Down like stairs making a Lower Low pattern ?',
        icon: FiLayers,
        detail: 'Look for strong selling pressure in the candle shapes. Upper wicks indicate rejection.',
        image: 'https://i.postimg.cc/JzYbhBmV/photo-collage-png-(3).png'
      },
      { 
        id: 'M', 
        title: 'Step M: Money Flow', 
        question: 'Is the Red Moneyflow line moving in a Downward direction ?',
        icon: FiSettings,
        detail: 'Capital should be exiting the asset for a sustainable drop. Red MFI indicates net outflow.',
        image: 'https://i.postimg.cc/8kFP8JXD/moneyflow-Down.png'
      },
      { 
        id: 'P', 
        title: 'Step P: Percentage', 
        question: 'Is the percentage table showing 78 or more percent and is Red in color ?',
        icon: FiBarChart2,
        detail: 'Ensure the potential drop profit justifies the stop-loss. Don\'t chase overextended moves.',
        image: 'https://i.postimg.cc/KjcPz71W/Downpercentage.png'
      }
    ]
  },
  'High Risk': {
    Buying: [
      { 
        id: 'M', 
        title: 'Step M: Money Flow', 
        question: 'Is the Green Moneyflow line moving in a Upward direction ?',
        icon: FiSettings,
        detail: 'High risk trades require aggressive capital support to overcome resistance levels.',
        image: 'https://i.postimg.cc/K8cHVVmc/MFhigh-Buying.png'
      },
      { 
        id: 'A', 
        title: 'Step A: Angle', 
        question: 'Is the angle line making more than 30 Degree with reference to the zero line (Central line) and pointing Upwards ?',
        icon: FiActivity,
        detail: 'Aggressive setups often rely on steep momentum angles indicating a parabolic move.',
        image: 'https://i.postimg.cc/SQB4Bmvw/Upanglehigh.png'
      },
      { 
        id: 'C', 
        title: 'Step C: Candle', 
        question: 'Are Green candles climbing UP like stairs making a Higher High pattern ?',
        icon: FiLayers,
        detail: 'High volume confirmation is critical for aggressive entries to ensure followers are present.',
        image: 'https://i.postimg.cc/jddKhWVF/photo-collage-png-(2).png'
      },
      { 
        id: 'P', 
        title: 'Step P: Percentage', 
        question: 'Is the percentage table showing 78 or more percent and is Green in color ?',
        icon: FiBarChart2,
        detail: 'Ensure volatility doesn\'t exceed your stop-loss tolerance in high-risk environments.',
        image: 'https://i.postimg.cc/63njRh53/uppercentage.png'
      }
    ],
    Selling: [
      { 
        id: 'M', 
        title: 'Step M: Money Flow', 
        question: 'Is the Red Moneyflow line moving in a Downward direction ?',
        icon: FiSettings,
        detail: 'Selling pressure must be backed by heavy selling volume to confirm a trend reversal.',
        image: 'https://i.postimg.cc/mrk2b8Ny/MFhigh-Selling.png'
      },
      { 
        id: 'A', 
        title: 'Step A: Angle', 
        question: 'Is the angle line making more than 30 Degree with reference to the zero line (Central line) and pointing Downwards ?',
        icon: FiActivity,
        detail: 'Aggressive shorts benefit from steep negative slopes indicating panic selling.',
        image: 'https://i.postimg.cc/9Qy65T7p/Down-Angle-High.png'
      },
      { 
        id: 'C', 
        title: 'Step C: Candle', 
        question: 'Are Red candles climbing Down like stairs making a Lower Low pattern ?',
        icon: FiLayers,
        detail: 'High risk shorts need definitive structural breaks to avoid being trapped in fakeouts.',
        image: 'https://i.postimg.cc/JzYbhBmV/photo-collage-png-(3).png'
      },
      { 
        id: 'P', 
        title: 'Step P: Percentage', 
        question: 'Is the percentage table showing 78 or more percent and is Red in color ?',
        icon: FiBarChart2,
        detail: 'Double check your risk exposure on this high-risk sell. High risk means high probability of stop-out.',
        image: 'https://i.postimg.cc/KjcPz71W/Downpercentage.png'
      }
    ]
  }
};

const TypingIndicator = () => (
  <div className="flex space-x-1 p-2 bg-white/5 rounded-2xl rounded-tl-none w-fit border border-white/5">
    <motion.div
      className="w-1.5 h-1.5 bg-blue-400 rounded-full"
      animate={{ y: [0, -5, 0] }}
      transition={{ duration: 0.6, repeat: Infinity, delay: 0 }}
    />
    <motion.div
      className="w-1.5 h-1.5 bg-purple-400 rounded-full"
      animate={{ y: [0, -5, 0] }}
      transition={{ duration: 0.6, repeat: Infinity, delay: 0.2 }}
    />
    <motion.div
      className="w-1.5 h-1.5 bg-pink-400 rounded-full"
      animate={{ y: [0, -5, 0] }}
      transition={{ duration: 0.6, repeat: Infinity, delay: 0.4 }}
    />
  </div>
);

const Chatbot = ({ currentStepData, currentStep, isOpen, setIsOpen, completed }) => {
  const [messages, setMessages] = useState([
    { role: 'bot', text: 'Hi! I am the ProfitLense Assistant. How can I help you today?' }
  ]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isTyping]);

  const generateResponse = (text) => {
    const lowerInput = text.toLowerCase();
    
    // Priority 1: Critical & Specific Commands
    if (lowerInput.includes('help')) {
      return "You can reach our support team at Support@profitlense.ai for any assistance.";
    }

    // Priority 2: Explicit requests for explanation
    if (lowerInput.includes('detail') || lowerInput.includes('explain') || lowerInput.includes('meaning') || lowerInput.includes('what')) {
      if (lowerInput.includes('next') || lowerInput.includes('do next')) {
         // Fall through to next priority for "what's next"
      } else if (currentStepData) {
        return `**${currentStepData.title}:** ${currentStepData.detail}`;
      } else {
        return "I can explain specific rules once you start the validation process.";
      }
    }

    // Priority 3: What's next? / Context-specific guidance
    if (lowerInput.includes('next') || lowerInput.includes('do next')) {
      if (completed) return "You have completed the setup. Click 'Start New Observer' to analyze another trade.";
      if (currentStepData) return "Verify if the rule matches your chart. Click 'True' if it does, or 'False' if it fails.";
      if (currentStep === 1) return "Click the 'Launch Guide' button to begin the setup wizard.";
      if (currentStep === 2) return "Please select a Trading Style: 'Low Risk' for conservative trades or 'High Risk' for aggressive ones.";
      if (currentStep === 3) return "Review the strategy pointers above. Once you're ready, click 'Let's Go'.";
      if (currentStep === 4) return "Are you planning to Buy (Bullish) or Sell (Bearish)? Select an action to proceed.";
    }
    
    // Default Context guidance if no specific triggering word
    if (!currentStepData && !lowerInput.includes('hello') && !lowerInput.includes('hi')) {
       if (currentStep === 1) return "Welcome! Please click 'Launch Guide' to start the setup wizard.";
    }

    // Priority 4: Greetings & Small Talk
    if (/\bhi\b/.test(lowerInput) || lowerInput.includes('hello')) {
      return "Hello there! Ready to validate some trades?";
    }

    if (lowerInput.includes('thank')) {
      return "You're welcome! Good luck with your trade.";
    }

    // Fallback
    return "I'm not sure about that. Try asking for 'details', 'what's next', or 'help'.";
  };

  const handleSend = (text = input) => {
    if (!text.trim()) return;

    const userMsg = { role: 'user', text: text };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setIsTyping(true);

    // Simulate network delay
    setTimeout(() => {
      const botResponse = generateResponse(text);
      setMessages(prev => [...prev, { role: 'bot', text: botResponse }]);
      setIsTyping(false);
    }, 1000);
  };

  const quickActions = [
    { label: "Explain this step", action: "Explain the details of this step" },
    { label: "What's next?", action: "What should I do next?" },
    { label: "Help", action: "I need help" }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex items-end gap-2">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.9, rotateX: 10 }}
            animate={{ opacity: 1, y: 0, scale: 1, rotateX: 0 }}
            exit={{ opacity: 0, y: 50, scale: 0.9, rotateX: 10 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="chat-window mb-4 w-[85vw] md:w-80 h-[500px] max-h-[70vh] bg-[#0a0a1a]/95 border border-white/10 rounded-3xl flex flex-col overflow-hidden shadow-2xl backdrop-blur-xl absolute bottom-16 right-0"
          >
            {/* Header */}
            <div className="p-4 bg-gradient-to-r from-indigo-900 to-slate-900 flex items-center justify-between shadow-lg border-b border-white/10">
              <div className="flex items-center gap-3 relative z-10">
                <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/20">
                  <span className="text-lg">🤖</span>
                </div>
                <div>
                  <h3 className="text-white font-black text-sm tracking-wide">ProfitLense AI</h3>
                  <div className="flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse"></span>
                    <span className="text-[10px] text-white/90 font-medium">Online</span>
                  </div>
                </div>
              </div>
              <button 
                onClick={() => setIsOpen(false)} 
                className="text-white/80 hover:text-white p-1 hover:bg-white/10 rounded-lg transition-colors"
              >
                <SafeIcon icon={FiX} className="w-5 h-5" />
              </button>
            </div>

            {/* Messages Area */}
            <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-4 custom-scrollbar bg-gradient-to-b from-transparent to-black/40">
              
              {messages.map((m, idx) => (
                <motion.div 
                  key={idx} 
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className={`flex ${m.role === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  <div className={`flex items-end gap-2 max-w-[85%] ${m.role === 'user' ? 'flex-row-reverse' : 'flex-row'}`}>
                    <div className={`w-6 h-6 rounded-full flex-shrink-0 flex items-center justify-center text-[10px] border ${m.role === 'user' ? 'bg-zinc-800 border-white/10 text-white' : 'bg-indigo-500/20 border-indigo-500/30 text-indigo-400'}`}>
                      <SafeIcon icon={m.role === 'user' ? FiUser : FiCpu} className="w-3 h-3" />
                    </div>
                    <div className={`p-3 rounded-2xl text-xs leading-relaxed shadow-sm ${
                      m.role === 'user' 
                        ? 'bg-gradient-to-br from-slate-700 to-slate-800 text-white rounded-br-none border border-white/10' 
                        : 'bg-white/5 text-white/90 rounded-bl-none border border-white/5'
                    }`}>
                      {m.text}
                    </div>
                  </div>
                </motion.div>
              ))}
              
              {isTyping && (
                <div className="flex justify-start">
                  <div className="flex items-end gap-2">
                    <div className="w-6 h-6 rounded-full bg-indigo-500/20 border border-indigo-500/30 flex items-center justify-center text-indigo-400">
                      <SafeIcon icon={FiCpu} className="w-3 h-3" />
                    </div>
                    <TypingIndicator />
                  </div>
                </div>
              )}
            </div>

            {/* Quick Actions */}
            <div className="px-4 pb-2 flex gap-2 overflow-x-auto no-scrollbar">
              {quickActions.map((action, idx) => (
                <button
                  key={idx}
                  onClick={() => handleSend(action.action)}
                  className="whitespace-nowrap px-3 py-1.5 bg-white/5 hover:bg-white/10 border border-white/10 rounded-full text-[10px] text-white/70 hover:text-white transition-colors flex-shrink-0"
                >
                  {action.label}
                </button>
              ))}
            </div>

            {/* Input Area */}
            <div className="p-3 bg-[#050510] border-t border-white/10">
              <div className="flex items-center gap-2 bg-black/40 border border-white/10 rounded-xl p-1 pl-3 focus-within:border-indigo-500/50 focus-within:ring-1 focus-within:ring-indigo-500/20 transition-all">
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleSend()}
                  placeholder="Ask a question..."
                  className="flex-1 bg-transparent text-xs text-white placeholder-white/30 focus:outline-none py-2"
                />
                <button 
                  onClick={() => handleSend()}
                  disabled={!input.trim()}
                  className="p-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-500 disabled:opacity-50 disabled:hover:bg-indigo-600 transition-colors shadow-lg shadow-indigo-600/20"
                >
                  <SafeIcon icon={FiSend} className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {!isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, x: -10 }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          className="bg-red-600 text-white text-[10px] font-bold px-3 py-1.5 rounded-l-full rounded-tr-full shadow-lg absolute bottom-14 right-0 whitespace-nowrap z-50 pointer-events-none"
        >
          Let's talk
        </motion.div>
      )}

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 p-[2px] rounded-full flex items-center justify-center shadow-[0_0_20px_rgba(255,100,100,0.5)] transition-all z-[60]"
      >
        <div className="w-full h-full bg-black rounded-full flex items-center justify-center relative overflow-hidden">
           <img src={LOGO_URL} alt="Chat" className="w-8 h-8 object-contain relative z-10" />
        </div>
      </motion.button>
    </div>
  );
};

const SetupImage = ({ src }) => {
  const [loading, setLoading] = useState(true);
  
  return (
    <div className="relative w-full flex justify-center py-2">
      <div className={`max-w-[280px] md:max-w-[360px] w-full min-h-[120px] md:min-h-[160px] rounded-xl overflow-hidden border border-white/10 shadow-2xl flex justify-center bg-black/40 p-1 relative ${loading ? 'animate-pulse' : ''}`}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 border-2 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin"></div>
          </div>
        )}
        <img 
          src={src} 
          alt="Setup Reference" 
          className={`max-w-full h-full object-contain transition-opacity duration-500 ${loading ? 'opacity-0' : 'opacity-100'}`}
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
};

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedStyle, setSelectedStyle] = useState('');
  const [selectedAction, setSelectedAction] = useState('');
  const [wizardStepIndex, setWizardStepIndex] = useState(-1);
  const [completed, setCompleted] = useState(false);
  const [failedRules, setFailedRules] = useState(false);
  const [failedStep, setFailedStep] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const urlsToPreload = [LOGO_URL];
    Object.values(WIZARD_CONFIG).forEach(riskLevel => {
      Object.values(riskLevel).forEach(actionSteps => {
        actionSteps.forEach(step => {
          if (step.image) urlsToPreload.push(step.image);
        });
      });
    });
    urlsToPreload.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }, []);

  const lowRiskOptions = [
    { code: 'A', label: 'Angle', icon: FiActivity },
    { code: 'B', label: 'Breakout', icon: FiTarget },
    { code: 'C', label: 'Candles', icon: FiLayers },
    { code: 'M', label: 'Money Flow', icon: FiSettings },
    { code: 'P', label: 'Percentage', icon: FiBarChart2 }
  ];

  const highRiskOptions = [
    { code: 'M', label: 'Money Flow', icon: FiSettings },
    { code: 'A', label: 'Angle', icon: FiActivity },
    { code: 'C', label: 'Candles', icon: FiLayers },
    { code: 'P', label: 'Percentage', icon: FiBarChart2 }
  ];

  const handleGetStarted = () => setCurrentStep(2);
  const handleStyleSelect = (style) => {
    setSelectedStyle(style);
    setCurrentStep(3);
  };
  const handleConfirmStyle = () => setCurrentStep(4);
  const handleActionSelect = (action) => {
    setSelectedAction(action);
    setWizardStepIndex(0);
  };

  const currentStepsList = (selectedStyle && selectedAction) 
    ? WIZARD_CONFIG[selectedStyle][selectedAction] 
    : [];

  const handleTrueSelect = () => {
    if (wizardStepIndex < currentStepsList.length - 1) {
      setWizardStepIndex(prev => prev + 1);
    } else {
      setFailedRules(false);
      setFailedStep(null);
      setCompleted(true);
    }
  };

  const handleFalseSelect = () => {
    setFailedStep(currentStepsList[wizardStepIndex]);
    setFailedRules(true);
    setCompleted(true);
  };

  const goBackWizardStep = () => {
    if (wizardStepIndex > 0) {
      setWizardStepIndex(prev => prev - 1);
    } else {
      setWizardStepIndex(-1);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setCompleted(false);
    }
  };

  const handleReset = () => {
    setCurrentStep(1);
    setSelectedStyle('');
    setSelectedAction('');
    setWizardStepIndex(-1);
    setCompleted(false);
    setFailedRules(false);
    setFailedStep(null);
  };

  const isSubWizard = wizardStepIndex !== -1 && !completed;
  const currentStepData = isSubWizard ? currentStepsList[wizardStepIndex] : null;

  const getThemeColors = () => {
    if (selectedAction === 'Buying') return {
      bg: 'to-emerald-950/40',
      accent: 'text-emerald-400',
      btn: 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-500/30',
      border: 'border-emerald-500/30'
    };
    if (selectedAction === 'Selling') return {
      bg: 'to-rose-950/40',
      accent: 'text-rose-500',
      btn: 'bg-rose-600 hover:bg-rose-700 shadow-rose-500/30',
      border: 'border-rose-500/30'
    };
    return {
      bg: 'to-indigo-950',
      accent: 'text-indigo-400',
      btn: 'bg-indigo-600 hover:bg-indigo-700 shadow-indigo-500/30',
      border: 'border-indigo-500/30'
    };
  };

  const theme = getThemeColors();

  return (
    <div className={`min-h-[100dvh] bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-indigo-950 via-slate-950 to-black flex items-center justify-center p-4 transition-all duration-1000 overflow-x-hidden relative`}>
      
      {/* Absolute Header */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2 w-full max-w-6xl px-4 flex justify-between items-center z-20">
        <div className="flex items-center gap-4 group cursor-pointer" onClick={handleReset}>
          <div className="w-20 h-20 bg-white/5 rounded-2xl flex items-center justify-center shadow-lg border border-white/10 group-hover:scale-110 transition-transform p-2 backdrop-blur-md">
            <img src={LOGO_URL} alt="Rocketalgo Logo" className="w-full h-full object-contain" />
          </div>
          <span className="text-2xl font-black text-white tracking-wider uppercase drop-shadow-md hidden sm:block">Profitlense.ai Setup Guide</span>
        </div>
        
        <div className="flex items-center gap-3 md:gap-6">
          <div className="flex items-center gap-4">
            <a 
              href="https://profitlense.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden md:flex items-center gap-2 text-[11px] font-black text-white bg-white/5 hover:bg-white/10 px-4 py-2 rounded-lg uppercase tracking-widest transition-all border border-white/10 backdrop-blur-md"
            >
              Profitlense.ai Official Site
              <SafeIcon icon={FiExternalLink} className="w-3 h-3" />
            </a>
            <a 
              href="https://buy.stripe.com/28EeV75zjdlv2hS6Cf7Vm01" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white text-[10px] font-black uppercase tracking-widest px-6 py-2.5 rounded-full transition-all shadow-lg shadow-blue-600/20 flex items-center gap-2"
            >
              <span>Subscribe Now</span>
              <SafeIcon icon={FiZap} className="w-3 h-3" />
            </a>
          </div>

          {!completed && currentStep > 1 && (
            <div className="hidden lg:flex items-center gap-3 text-white text-[10px] font-bold uppercase tracking-widest bg-white/5 px-4 py-2 rounded-full border border-white/5 backdrop-blur-sm">
              <span>Setup Wizard</span>
              <div className="w-1 h-1 bg-white/20 rounded-full"></div>
              <span className="text-indigo-400">V2.5.0</span>
            </div>
          )}
        </div>
      </div>

      <div className="w-full max-w-5xl mx-auto pt-24 pb-32">
        <AnimatePresence>
          {((currentStep > 1 && !isSubWizard) || (isSubWizard)) && !completed && (
            <motion.div
              key="back-button"
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -10 }}
              className="mb-4"
            >
              <button
                onClick={isSubWizard ? goBackWizardStep : handleBack}
                className={`flex items-center gap-2 text-white hover:text-white bg-white/10 border border-white/20 px-3 py-1.5 rounded-lg transition-all duration-300 group touch-manipulation backdrop-blur-sm`}
              >
                <SafeIcon icon={FiArrowLeft} className="w-3.5 h-3.5 group-hover:-translate-x-1 transition-transform" />
                <span className="font-bold text-[10px] uppercase tracking-widest">Back</span>
              </button>
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence mode="wait">
          {currentStep === 1 && (
            <motion.div
              key="step1"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              className="flex flex-col items-center justify-center space-y-8 pt-8"
            >
              <div className="text-center space-y-6 px-4">
                <motion.div 
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  className="flex flex-col items-center justify-center mb-8"
                >
                  <div className="flex items-center gap-2 bg-gradient-to-r from-violet-600 to-indigo-600 px-4 py-1.5 rounded-full mb-8 shadow-lg shadow-indigo-500/20">
                    <span className="text-[10px] font-black tracking-[0.2em] text-white uppercase">Trade with Mind of AI</span>
                  </div>
                  
                  <div className="w-48 h-48 md:w-64 md:h-64 bg-white/5 rounded-[2.5rem] p-8 shadow-2xl border border-white/10 backdrop-blur-xl mb-4 relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-tr from-indigo-500/10 to-transparent"></div>
                    <img src={LOGO_URL} alt="Rocketalgo Logo Large" className="w-full h-full object-contain relative z-10" />
                  </div>
                </motion.div>
                
                <div className="space-y-2">
                  <h1 className="text-4xl md:text-7xl font-black text-white tracking-tighter leading-[0.9] drop-shadow-2xl">
                    OBSERVE<br /><span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400">PROFITLENSE.AI</span><br />SETUP
                  </h1>
                </div>
                
                <p className="text-base md:text-xl text-white/70 font-medium tracking-tight max-w-xl mx-auto leading-relaxed">
                  Precision trading guided by advanced algorithmic rules. Validate your next move with confidence.
                </p>
              </div>
              <motion.button
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleGetStarted}
                className="bg-gradient-to-r from-pink-600 to-rose-600 hover:from-pink-500 hover:to-rose-500 text-white px-12 py-5 text-lg font-black rounded-full shadow-[0_20px_40_rgba(244,63,94,0.3)] transition-all duration-300 touch-manipulation uppercase tracking-[0.2em]"
              >
                Launch Guide
              </motion.button>
            </motion.div>
          )}

          {currentStep === 2 && (
            <motion.div
              key="step2"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              className="px-2"
            >
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-3xl md:text-4xl font-black text-white mb-2 tracking-tighter">TRADING STYLE</h2>
                <p className="text-white/80 text-sm md:text-base font-medium">Select your preferred risk management profile</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-4xl mx-auto">
                <motion.button
                  whileHover={{ scale: 1.02, y: -5 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => handleStyleSelect('Low Risk')}
                  className="relative overflow-hidden bg-zinc-900/50 border-2 border-white/10 hover:border-emerald-500 p-8 md:p-10 rounded-[2.5rem] flex flex-col items-center gap-6 group transition-all shadow-xl backdrop-blur-md"
                >
                  <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
                    <SafeIcon icon={FiShield} className="w-20 h-20" />
                  </div>
                  <div className="w-16 h-16 bg-emerald-500/10 rounded-2xl flex items-center justify-center text-emerald-500 group-hover:bg-emerald-500 group-hover:text-white transition-all duration-500">
                    <SafeIcon icon={FiShield} className="w-8 h-8" />
                  </div>
                  <div className="text-center relative z-10">
                    <span className="text-2xl md:text-3xl font-black text-white block mb-1 tracking-tighter">LOW RISK</span>
                    <span className="text-emerald-500 text-[10px] font-black uppercase tracking-[0.15em] bg-emerald-500/10 px-3 py-0.5 rounded-full">Conservative</span>
                  </div>
                  <div className="w-full h-1 bg-white/5 rounded-full overflow-hidden">
                    <div className="w-1/3 h-full bg-emerald-500"></div>
                  </div>
                </motion.button>

                <motion.button
                  whileHover={{ scale: 1.02, y: -5 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => handleStyleSelect('High Risk')}
                  className="relative overflow-hidden bg-zinc-900/50 border-2 border-white/10 hover:border-indigo-500 p-8 md:p-10 rounded-[2.5rem] flex flex-col items-center gap-6 group transition-all shadow-xl backdrop-blur-md"
                >
                  <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
                    <SafeIcon icon={FiTrendingUp} className="w-20 h-20" />
                  </div>
                  <div className="w-16 h-16 bg-indigo-500/10 rounded-2xl flex items-center justify-center text-indigo-500 group-hover:bg-indigo-500 group-hover:text-white transition-all duration-500">
                    <SafeIcon icon={FiTrendingUp} className="w-8 h-8" />
                  </div>
                  <div className="text-center relative z-10">
                    <span className="text-2xl md:text-3xl font-black text-white block mb-1 tracking-tighter">HIGH RISK</span>
                    <span className="text-indigo-500 text-[10px] font-black uppercase tracking-[0.15em] bg-indigo-500/10 px-3 py-0.5 rounded-full">Aggressive</span>
                  </div>
                  <div className="w-full h-1 bg-white/5 rounded-full overflow-hidden">
                    <div className="w-full h-full bg-indigo-500"></div>
                  </div>
                </motion.button>
              </div>
            </motion.div>
          )}

          {currentStep === 3 && (
            <motion.div
              key="step3"
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              className="max-w-4xl mx-auto px-4"
            >
              <div className="bg-zinc-900/60 backdrop-blur-3xl border-2 border-white/10 rounded-[2.5rem] p-6 md:p-10 text-center shadow-2xl relative overflow-hidden">
                <div className="absolute -top-16 -left-16 w-48 h-48 bg-indigo-500/10 blur-[80px] rounded-full"></div>
                
                <div className="flex justify-center mb-4 relative">
                  <div className={`w-14 h-14 ${selectedStyle === 'Low Risk' ? 'bg-emerald-500/20 text-emerald-500' : 'bg-indigo-500/20 text-indigo-500'} rounded-2xl flex items-center justify-center shadow-lg border border-white/10`}>
                    <SafeIcon icon={selectedStyle === 'Low Risk' ? FiShield : FiTrendingUp} className="w-7 h-7" />
                  </div>
                </div>

                <h2 className="text-3xl md:text-5xl font-black text-white mb-2 tracking-tighter uppercase relative">
                  {selectedStyle} Setup
                </h2>
                <p className="text-white/80 text-sm md:text-base font-medium mb-8 tracking-tight">
                  The following <span className="text-indigo-400 font-bold">Profitlense.ai</span> pointers must be validated:
                </p>
                
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-8 relative">
                  {(selectedStyle === 'Low Risk' ? lowRiskOptions : highRiskOptions).map((opt, idx) => (
                    <motion.div 
                      key={opt.code}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: idx * 0.05 }}
                      className="bg-zinc-800/30 border border-white/5 p-5 md:p-6 rounded-2xl flex flex-col items-center justify-center gap-3 group hover:bg-zinc-800/50 transition-all hover:border-indigo-500/30 hover:-translate-y-1 shadow-lg backdrop-blur-sm"
                    >
                      <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center text-white/80 group-hover:text-indigo-400 transition-colors">
                        <SafeIcon icon={opt.icon} className="w-5 h-5" />
                      </div>
                      <div className="text-center">
                        <span className="text-indigo-400 font-black text-3xl md:text-4xl block leading-none mb-1 drop-shadow-[0_0_10px_rgba(129,140,248,0.2)] group-hover:scale-105 transition-transform">
                          {opt.code}
                        </span>
                        <span className="text-white font-black text-[8px] md:text-[10px] uppercase tracking-[0.15em]">
                          {opt.label}
                        </span>
                      </div>
                    </motion.div>
                  ))}
                </div>

                <motion.button
                  whileHover={{ scale: 1.02, y: -2 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={handleConfirmStyle}
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white py-4 md:py-6 rounded-2xl font-black text-lg md:text-xl shadow-[0_15px_30px_rgba(79,70,229,0.2)] uppercase tracking-[0.2em] transition-all relative z-10"
                >
                  Let's Go
                </motion.button>
              </div>
            </motion.div>
          )}

          {currentStep === 4 && !isSubWizard && !completed && (
            <motion.div
              key="step4"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              className="px-4"
            >
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-3xl md:text-4xl font-black text-white mb-2 tracking-tighter">MARKET ACTION</h2>
                <p className="text-white/80 text-sm md:text-base font-medium">Strategy: <span className="text-indigo-400 font-black uppercase">{selectedStyle}</span></p>
              </div>
              <div className="flex flex-col md:flex-row gap-4 md:gap-8 justify-center items-center max-w-3xl mx-auto">
                <motion.button
                  whileHover={{ scale: 1.05, y: -5 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => handleActionSelect('Buying')}
                  className="w-full md:w-72 h-36 md:h-48 bg-gradient-to-br from-emerald-600 to-emerald-900 text-white text-2xl font-black rounded-[2.5rem] shadow-[0_20px_40px_rgba(16,185,129,0.2)] touch-manipulation uppercase tracking-wider flex flex-col items-center justify-center gap-3 border border-white/10"
                >
                  <SafeIcon icon={FiArrowLeft} className="w-8 h-8 rotate-90" />
                  Buying
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05, y: -5 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => handleActionSelect('Selling')}
                  className="w-full md:w-72 h-36 md:h-48 bg-gradient-to-br from-rose-600 to-rose-900 text-white text-2xl font-black rounded-[2.5rem] shadow-[0_20px_40px_rgba(244,63,94,0.2)] touch-manipulation uppercase tracking-wider flex flex-col items-center justify-center gap-3 border border-white/10"
                >
                  <SafeIcon icon={FiArrowLeft} className="w-8 h-8 -rotate-90" />
                  Selling
                </motion.button>
              </div>
            </motion.div>
          )}

          {isSubWizard && currentStepData && (
            <motion.div
              key={`${selectedStyle}-${selectedAction}-${currentStepData.id}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="max-w-3xl mx-auto px-2"
            >
              <div className={`bg-zinc-900/70 backdrop-blur-3xl border-2 ${theme.border} rounded-[2.5rem] p-6 md:p-10 shadow-2xl relative overflow-hidden`}>
                <div className="absolute top-0 left-0 w-full h-1.5 bg-white/5">
                  <motion.div 
                    initial={{ width: 0 }}
                    animate={{ width: `${((wizardStepIndex + 1) / currentStepsList.length) * 100}%` }}
                    className={`h-full ${selectedAction === 'Buying' ? 'bg-emerald-500' : 'bg-rose-500'}`}
                  />
                </div>

                <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-8">
                  <div className={`w-16 h-16 md:w-20 md:h-20 bg-white/10 rounded-2xl flex items-center justify-center ${theme.accent} border border-white/20 shadow-inner`}>
                    <SafeIcon icon={currentStepData.icon} className="w-8 h-8 md:w-10 md:h-10" />
                  </div>
                  <div className="text-center md:text-left pt-1">
                    <h2 className="text-2xl md:text-3xl font-black text-white tracking-tighter mb-1.5">{currentStepData.title}</h2>
                    <div className="flex flex-wrap justify-center md:justify-start gap-2">
                      <span className={`${theme.accent} text-[9px] font-black tracking-[0.15em] uppercase bg-white/10 px-2.5 py-0.5 rounded-full border border-white/10`}>{selectedStyle}</span>
                      <span className={`${theme.accent} text-[9px] font-black tracking-[0.15em] uppercase bg-white/10 px-2.5 py-0.5 rounded-full border border-white/10`}>{selectedAction}</span>
                      <span className="text-white text-[9px] font-black tracking-[0.15em] uppercase bg-white/10 px-2.5 py-0.5 rounded-full border border-white/10">Rule {wizardStepIndex + 1}/{currentStepsList.length}</span>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  {currentStepData.image && (
                    <SetupImage src={currentStepData.image} />
                  )}

                  <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-10 text-center min-h-[140px] flex flex-col justify-center shadow-inner relative group">
                    <div className="absolute top-3 right-3 text-white/20 group-hover:text-indigo-400 transition-colors">
                      <SafeIcon icon={FiInfo} className="w-6 h-6" />
                    </div>
                    <h3 className="text-xl md:text-2xl text-white font-bold mb-4 leading-snug tracking-tight">
                      {currentStepData.question}
                    </h3>
                    <p className="text-white/70 text-[11px] md:text-xs font-medium italic max-w-xl mx-auto leading-relaxed">
                      {currentStepData.detail}
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <motion.button
                      whileHover={{ scale: 1.02, y: -3 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleTrueSelect}
                      className="bg-emerald-600 hover:bg-emerald-500 text-white font-black py-4 md:py-6 rounded-xl shadow-[0_10px_20px_rgba(16,185,129,0.15)] transition-all flex items-center justify-center gap-3 touch-manipulation text-base uppercase tracking-widest border border-white/10"
                    >
                      <SafeIcon icon={FiCheck} className="w-5 h-5" strokeWidth={3} />
                      True
                    </motion.button>
                    <motion.button
                      whileHover={{ scale: 1.02, y: -3 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleFalseSelect}
                      className="bg-rose-600 hover:bg-rose-500 text-white font-black py-4 md:py-6 rounded-xl shadow-[0_10px_20_rgba(244,63,94,0.15)] transition-all flex items-center justify-center gap-3 touch-manipulation text-base uppercase tracking-widest border border-white/10"
                    >
                      <SafeIcon icon={FiX} className="w-5 h-5" strokeWidth={3} />
                      False
                    </motion.button>
                  </div>
                </div>
              </div>
            </motion.div>
          )}

          {completed && (
            <motion.div
              key="final"
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              className="flex flex-col items-center justify-center space-y-8 text-center px-4 py-8"
            >
              <div className="relative">
                <motion.div
                  initial={{ scale: 0, rotate: -45 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ type: "spring", stiffness: 200, delay: 0.1 }}
                  className={`w-24 h-24 md:w-32 md:h-32 rounded-[2.5rem] flex items-center justify-center shadow-2xl relative z-10 ${failedRules ? 'bg-rose-500 shadow-rose-500/40' : 'bg-emerald-500 shadow-emerald-500/40'}`}
                >
                  <SafeIcon icon={failedRules ? FiX : FiCheck} className="w-10 h-10 md:w-14 md:h-14 text-white" strokeWidth={4} />
                </motion.div>
                <div className={`absolute inset-0 blur-2xl opacity-20 ${failedRules ? 'bg-rose-500' : 'bg-emerald-500'}`}></div>
              </div>
              
              <div className="space-y-4 max-w-2xl px-2">
                <h2 className="text-4xl md:text-6xl font-black text-white mb-4 tracking-tighter uppercase leading-none">
                  {failedRules ? <>SETUP<br />FAILED</> : <>SETUP<br />COMPLETE</>}
                </h2>
                
                {failedRules ? (
                  <div className="bg-rose-500/10 border border-rose-500/20 p-6 rounded-2xl">
                    <p className="text-lg md:text-xl text-rose-500 font-black leading-tight uppercase tracking-tight mb-2">
                      CRITICAL: Rule Violation detected.
                    </p>
                    {failedStep && (
                      <div className="flex items-center justify-center gap-2 bg-rose-500/20 py-2 px-4 rounded-xl border border-rose-500/30">
                        <SafeIcon icon={failedStep.icon} className="w-4 h-4 text-rose-500" />
                        <span className="text-white font-black text-xs uppercase tracking-widest">Failed at {failedStep.title}</span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="bg-emerald-500/10 border border-emerald-500/20 p-6 rounded-2xl">
                    <p className="text-lg md:text-xl text-white font-bold leading-tight tracking-tight">
                      Your <span className={theme.accent + " font-black uppercase"}>{selectedStyle}</span> setup for <span className={theme.accent + " font-black uppercase"}>{selectedAction}</span> is valid.
                    </p>
                  </div>
                )}

                <div className="mt-8 p-8 bg-zinc-900/50 backdrop-blur-xl rounded-[2.5rem] border border-white/10 inline-block text-left w-full max-w-md shadow-2xl">
                  <div className="space-y-4">
                    <div className="flex justify-between items-center border-b border-white/10 pb-3">
                      <span className="text-white/80 font-black uppercase tracking-widest text-[10px]">Strategy</span>
                      <span className="text-white font-black text-lg tracking-tighter">{selectedStyle}</span>
                    </div>
                    <div className="flex justify-between items-center border-b border-white/10 pb-3">
                      <span className="text-white/80 font-black uppercase tracking-widest text-[10px]">Action</span>
                      <span className={`${theme.accent} font-black text-lg tracking-tighter`}>{selectedAction}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-white/80 font-black uppercase tracking-widest text-[10px]">Final Verdict</span>
                      <span className={failedRules ? 'text-rose-500 font-black text-lg tracking-tighter' : 'text-emerald-500 font-black text-lg tracking-tighter'}>
                        {failedRules ? 'NO TRADE' : 'VALID ENTRY'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <button
                onClick={handleReset}
                className="bg-white hover:bg-zinc-200 text-black px-12 py-5 rounded-2xl font-black text-base uppercase tracking-[0.15em] transition-all touch-manipulation shadow-xl"
              >
                Start New Observer
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <Chatbot 
        currentStepData={currentStepData} 
        currentStep={currentStep}
        isOpen={isChatOpen} 
        setIsOpen={setIsChatOpen}
        completed={completed}
      />

      {/* Footer Branding */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center w-full px-4 z-50">
        <div className="text-white/70 text-[10px] font-black uppercase tracking-[0.3em] mb-3">
          © Profitlense.AI LLC 2026 · All Rights Reserved
        </div>
        
        <div className="flex items-center justify-center group">
          <div className="bg-black/40 backdrop-blur-md border border-white/10 px-6 py-2 rounded-full flex items-center gap-3 shadow-2xl">
            <span className="text-white/80 text-[10px] font-black uppercase tracking-widest">Contact Us:</span>
            <a 
              href="mailto:Support@profitlense.ai" 
              className="text-indigo-400 text-sm md:text-base font-black tracking-widest hover:scale-105 transition-transform"
            >
              Support@profitlense.ai
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;